/** Pure label resolution for bus `interact:prompt` payloads (unit tested). */
import type { EventPayloads } from '@/core/events';
import type { Events } from '@/core/events';

export type InteractPromptPayload = EventPayloads[typeof Events.INTERACT_PROMPT];

/** Default verb per interaction kind (中文). */
export const KIND_LABELS: Record<NonNullable<NonNullable<InteractPromptPayload>['kind']>, string> = {
  talk: '交谈',
  observe: '查看',
  trigger: '查看',
  exit: '进入',
};

/** Explicit label wins; otherwise the kind's verb; otherwise 查看. */
export function promptLabel(p: NonNullable<InteractPromptPayload>): string {
  const explicit = p.label?.trim();
  if (explicit) return explicit;
  if (p.kind && KIND_LABELS[p.kind]) return KIND_LABELS[p.kind];
  return '查看';
}
